import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { GoogleRegister } from '../../../../../libs/shared/src/lib/models/dashboard/user-from-be';

@Injectable({
  providedIn: 'root',
})
export class GoogleAuthService {
  currentGoogleUserSubject: BehaviorSubject<GoogleRegister | null> = new BehaviorSubject<GoogleRegister | null>(null);
  currentGoogleUser$ = this.currentGoogleUserSubject.asObservable();

  sendGoogleUserData(user: GoogleRegister) {
    this.currentGoogleUserSubject.next(user);
  }

  clearGoogleUserData() {
    this.currentGoogleUserSubject.next(null);
  }
}
